import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Grid, Row, FormControl, FormGroup, ControlLabel } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";


class NewSubstanceForm extends React.Component {

    render() {

        return (
            <Grid fluid>
                <Row>
                    <Col md={12} style={{ marginBottom: "16px" }}>
                        <Link to="/app/substance/liste">
                            <Button bsStyle="default" fill bsSize="lg">
                                Retour
                            </Button>
                        </Link>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}>
                        <Card
                            content=
                            {

                                <Row>
                                    <Col xs={12} sm={6} md={6}>
                                        <FormGroup>
                                            <ControlLabel>Nom</ControlLabel>
                                            <FormControl
                                                placeholder="Nom de la Substance *"
                                                type="text"
                                                onChange={(val) => this.props.setName(val.target.value)}
                                                defaultValue={this.props.stateName}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={12} sm={6} md={6}>
                                        <FormGroup>
                                            <ControlLabel>Value</ControlLabel>
                                            <FormControl
                                                placeholder="Value"
                                                type="text"
                                                onChange={(val) => this.props.setValue(val.target.value)}
                                                defaultValue={this.props.stateValue}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        )
    }
}

NewSubstanceForm.propTypes = {
    state: PropTypes.object,
    setValue: PropTypes.func,
    setName: PropTypes.func,
    stateValue: PropTypes.string,
    stateName: PropTypes.string
};

export default NewSubstanceForm;

